import { Card, IconButton } from '@material-ui/core';
import { ExitToApp, LinkOutlined, SmartphoneOutlined } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import EmailIconOutlined from '@material-ui/icons/EmailOutlined';
import WarningIcon from '@material-ui/icons/WarningOutlined';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { Field, FieldArray, change, reduxForm } from 'redux-form';
import { MOBILE_UDID_STATES, ORANGE, RED } from '../../_config/consts.js';
import { isValidEmail } from '../../_config/utils.js';
import BuildingSettingIconCustom from '../CustomIcons/BuildingSettingIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import MDRadioButtonsGroupField from './Elements/MDRadioButtonsGroup/MDRadioButtonsGroupField.js';
import CustomField from './Fields/CustomField.jsx';
import EmailAutocompleteField from './Fields/EmailAutocompleteField.jsx';
import TranslatableOption from './Fields/TranslatableOption.jsx';
import InfoSection from '../InfoSection/InfoSection.jsx';


const timeUnitsOptions = [
  {
    entity: 'minutes',
    value: 'minutes',
  },
  {
    entity: 'hoursStartCase',
    value: 'hours',
  },
  {
    entity: 'daysStartCase',
    value: 'days',
  },
];

const onRenderTestEmails = (props) => {
  const { fields, formData, onInitializeNewEmail, usersOptions = [], meta } = props;
  const numberOfEmails = _.size(fields);
  const hasFieldsError = meta && meta.error;
  
  return (
    <div style={{}}>
      <div style={{ marginBottom: 15, paddingLeft: 0 }}>
        <h4 style={{ color: '#3f3f3f', marginBottom: 5, fontWeight: 'bold', fontSize: 16 }}>
          <Entity entity="notificationEmailsList" />
        </h4>
      </div>
      {fields && fields.map((email, index) => (
        <div key={`testEmails${index + 1}`} elevation={2} style={{width:'fit-content', marginBottom: 15}}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', paddingRight: 10 }}>
            <div style={{ paddingLeft: 0, width: 500 }}>
              <Field
                name={`testEmails[${index}]`}
                component={CustomField}
                containerStyle={{ marginLeft: 0 }}
                className="form-control-select"
                componentClass="select"
              >
                {_.map(usersOptions, user =>
                  <Entity
                    key={user.value}
                    componentClass={TranslatableOption}
                    value={user.value}
                    componentAttribute="text"
                    entity={user.label}
                  />)}
              </Field>
            </div>
            <IconButton
              style={{ marginLeft: 5, marginTop: 0 }}
              disabled={props.disabled}
              onClick={(e) => {
                e.stopPropagation();
                if (!formData.isEditing) {
                  fields.remove(index);
                }
              }}
            >
              <DeleteIcon style={{ color: RED, fontSize: 20 }} />
            </IconButton>
          </div>
        </div>
      ))}
      {!props.disabled ? (
        <Card
          style={{ height: 40, marginBottom: 20, padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', width:'fit-content', cursor: 'pointer', border: hasFieldsError ? `2px solid ${RED}` : '1px solid #e0e0e0' }}
          className="card card-rounded"
          onClick={() => {
            fields.push({});
            onInitializeNewEmail(numberOfEmails);
          }}
        >
          <AddIcon style={{ color: hasFieldsError ? RED : '#4DB6AC', marginRight: 15, fontSize: 25 }} />
          <h4 style={{ fontWeight: 'bold', marginTop:0, marginBottom:0, color: hasFieldsError ? RED : '#3f3f3f' }}>
            <Entity entity="newResourceReservationAutomaticEmail" />
          </h4>
        </Card>
      ) : null}
    </div>
  );
};

const validate = (values) => {
  const errors = {};
  if (values.sessionTimeoutEnabled === 1 && (!values.sessionTimeoutSeconds || values.sessionTimeoutSeconds <= 0)) {
    errors.sessionTimeoutSeconds = 'required';
  }
  
  if (values.testEmails && values.testEmails.length > 0) {
    values.testEmails.forEach((email, i) => {
      if (!isValidEmail(email, true)) {
        if (!errors.testEmails) 
          errors.testEmails = [];
        errors.testEmails[i] = 'invalid';
      }
    });
  }

  if (values.sessionTimeoutSeconds && values.sessionTimeoutSeconds <= 0) {
    errors.sessionTimeoutSeconds = 'required';
  }
  
  return errors;
};

@reduxForm({ form: 'SystemSettingsForm', validate })
class SystemSettingsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usersOptions: props.usersOptions || [],
    };
  }

  componentDidMount() {
    this.onFilterUsers(undefined);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.usersOptions && this.props.usersOptions) {
      this.onFilterUsers(undefined);
    }
  }

  onFilterUsers(value) {
    const { usersOptions = [] } = this.props;
    this.setState({ usersOptions });
  }

  onInitializeNewEmail(emailId, fieldName) {
    const { dispatch } = this.props;    
    dispatch(change('SystemSettingsForm', `${fieldName}[${emailId}]`, ""));
  }

  render() {
    const { 
      isDeviceManagementActive, 
      onSelectInvitationGuestOption, 
      isInvitationActive,
      formValues,
      onSelectSessionTimeoutOption,
      onSelectSessionTimeoutUnit,
      onSendTestEmail,
    } = this.props;
    const { usersOptions } = this.state;
    const deviceUUIDModeOptions = [
      {
        label: <Entity entity="limitDeviceUUIDToOne" />,
        value: MOBILE_UDID_STATES.NEVER_SET,
      },
      {
        label: <Entity entity="unlimitDeviceUUID" />,
        value: MOBILE_UDID_STATES.ALWAYS_VALID,
      },
    ];
    
    const invitationModeOptions = [
      {
        label: <Entity entity="invitationGuestModeDisabled" />,
        value: 0,
      },
      {
        label: <Entity entity="invitationGuestModeEnabledWitoutLimit" />,
        value: -1,
      },
      // {
      //   label: <Entity entity="invitationGuestModeEnabledWithLimit" />,
      //   value: 1,
      // }
    ];

    const sessionTimeoutModeOptions = [
      {
        label: <Entity entity="sessionTimeoutDisabled" />,
        value: 0,
      },
      {
        label: <Entity entity="sessionTimeoutEnabled" />,
        value: 1,
      },
    ];
    const isInvitationGuestEnabled = formValues && formValues.values && formValues.values.guestInvitationLimitDefault && (formValues.values.guestInvitationLimitDefault !== 0 && formValues.values.guestInvitationLimitDefault !== -1);
    const isSessionTimeoutEnabled = formValues && formValues.values && formValues.values.sessionTimeoutEnabled === 1;
    const testEmails = formValues && formValues.values && formValues.values.testEmails;
    const isTestEmailsEnabled = testEmails && testEmails.length > 0 && testEmails.every(email => isValidEmail(email, true));
    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
          <BuildingSettingIconCustom style={{ color: '#3f3f3f', width: 20 }} />
          <h3 style={{ color: '#3f3f3f', fontWeight: 'bold', margin: 0, marginLeft: 10, fontSize: 24 }}>
            <Entity entity="settings" />
          </h3>
        </div>
        <h4 style={{ fontSize: 20, marginTop: 0, color: '#3f3f3f', fontWeight: 200, lineHeight: '1.5em' }}><Entity entity="systemSettingsDescription" /></h4>
        {isDeviceManagementActive ? (
          <FormFlatContainer
            title="mobileUUIDModeTitle"
            subtitle="mobileUUIDModeDescription"
            icon={<SmartphoneOutlined style={{ marginLeft: 0, marginTop: 0, fontSize: 20, color: '#3f3f3f' }} />}
            containerStyle={{ marginRight: 10, marginTop: 20 }}
          >
            <Field
              name="mobileUuidDefaultState"
              title={<Entity entity="deviceUUIDMode" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              options={deviceUUIDModeOptions}
            />
          </FormFlatContainer>
        ) : null}
        {isInvitationActive ? (
          <FormFlatContainer
            title="invitationGuestModeTitle"
            subtitle="invitationGuestModeDescription"
            icon={<LinkOutlined style={{ marginLeft: 0, marginTop: 0, fontSize: 20, color: '#3f3f3f' }} />}
            containerStyle={{ marginRight: 10, marginTop: 20 }}
          >
            <Field
              name="guestInvitationLimitDefault"
              title={<Entity entity="invitationGuestSettingState" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              options={invitationModeOptions}
              onHandleChange={(value) => onSelectInvitationGuestOption(value)}
            />
            {/* {isInvitationGuestEnabled ? (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h5 style={{ color: '#3f3f3f', marginRight: 10, marginLeft: 30, marginTop: 0 }}>{<Entity entity="maxNumberActiveInvitations" />}</h5>
                <Entity
                  componentClass={Field}
                  name="invitationLimit"
                  title=""
                  type="number"
                  componentAttribute="placeholder"
                  component={CustomField}
                  hideErrorLabel
                  containerStyle={{ width: 100 }}
                  className="form-control-custom"
                  onHandleChange={value => onHandleChangeInvitationLimit(value)}
                />  
              </div>
            ) : null} */}
          </FormFlatContainer>
        ) : null}
        <FormFlatContainer
          title="sessionTimeoutTitle"
          subtitle="sessionTimeoutDescription"
          icon={<ExitToApp style={{ marginLeft: 0, marginTop: 0, fontSize: 20, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 10, marginTop: 20 }}
        >
          <Field
            name="sessionTimeoutEnabled"
            title={<Entity entity="sessionTimeoutState" />}
            component={MDRadioButtonsGroupField}
            containerstyle={{ paddingLeft: 15, marginTop: 0 }}
            showErrorLabel
            options={sessionTimeoutModeOptions}
            onHandleChange={(value) => onSelectSessionTimeoutOption && onSelectSessionTimeoutOption(value)}
          />
          {isSessionTimeoutEnabled ? (
            <div>
              <div style={{ marginLeft: 14, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 style={{ color: '#3f3f3f', marginRight: 10, marginTop: 0, fontSize: 16 }}>{<Entity entity="sessionTimeoutValue" />}</h4>
                <Entity
                  componentClass={Field}
                  name="sessionTimeoutSeconds"
                  type="number"
                  componentAttribute="placeholder"
                  component={CustomField}
                  hideErrorLabel
                  containerStyle={{ width: 100 }}
                  className="form-control-custom"
                />
                <Field
                  id="sessionTimeoutUnit"
                  name="sessionTimeoutUnit"
                  component={CustomField}
                  containerStyle={{ marginLeft: 20 }}
                  className="form-control-select"
                  onHandleChange={value => onSelectSessionTimeoutUnit(value)}
                  componentClass="select"
                >
                  {_.map(timeUnitsOptions, type =>
                    <Entity
                      key={type.value}
                      componentClass={TranslatableOption}
                      value={type.value}
                      componentAttribute="text"
                      entity={type.entity}
                    />)}
                </Field>
              </div>
              <InfoSection
                title="sessionTimeoutWarning"
                gravity="warning"
                titleStyle={{ fontWeight: 'normal' }}
              />
            </div>
          ) : null}
        </FormFlatContainer>
        
        <FormFlatContainer
          title="testEmailServiceTitle"
          subtitle="testEmailServiceDescription"
          icon={<EmailIconOutlined style={{ marginLeft: 0, marginTop: 0, fontSize: 20, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 10, marginTop: 20 }}
        >
          <div style={{ marginTop: 20, paddingLeft: 0 }}>
            <FieldArray
              name={`testEmails`}
              component={onRenderTestEmails}
              formData={formValues && formValues.values}
              form={formValues}
              disabled={false}
              usersOptions={usersOptions}
              onInitializeNewEmail={emailId => this.onInitializeNewEmail(emailId, `testEmails`)}
            />
            <MDButton
              disabled={!isTestEmailsEnabled}
              title={<Entity entity="sendTestEmail" />}
              style={{ borderRadius: 5, marginTop: 10, opacity: !isTestEmailsEnabled ? 0.5 : 1 }}
              onClick={() => onSendTestEmail && onSendTestEmail(formValues.values.testEmails)}
            />
          </div>
        </FormFlatContainer>
      </div>
    );
  }
} 

export default SystemSettingsForm;
